import { render, staticRenderFns } from "./SimulationsNoneFound.vue?vue&type=template&id=2b331672&scoped=true&"
import script from "./SimulationsNoneFound.vue?vue&type=script&lang=js&"
export * from "./SimulationsNoneFound.vue?vue&type=script&lang=js&"
import style0 from "./SimulationsNoneFound.vue?vue&type=style&index=0&id=2b331672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b331672",
  null
  
)

export default component.exports